import React from 'react';
import {
  CircularProgress,
  Button as MuiButton,
  ButtonProps as MuiButtonProps,
} from '@mui/material';

export interface LoadingButtonProps extends MuiButtonProps {
  loading?: boolean;
}

function getProgressSize(btnSize: LoadingButtonProps['size']): number {
  if (btnSize === 'small') {
    return 18;
  }
  if (btnSize === 'large') {
    return 26;
  }
  return 24;
}

export const LoadingButton: React.FC<LoadingButtonProps> = ({
  loading,
  children,
  ...buttonProps
}) => {
  return (
    <MuiButton {...buttonProps}>
      {loading && (
        <CircularProgress
          sx={{ color: 'inherit', position: 'absolute' }}
          size={getProgressSize(buttonProps.size)}
        />
      )}
      <span style={{ visibility: loading ? 'hidden' : undefined }}>
        {children}
      </span>
    </MuiButton>
  );
};
